const mmddyyyyToDate = date => {
  const split = date.split('/');
  return new Date(`${split[2]}-${split[0]}-${split[1]}`);
};

export default mmddyyyyToDate;
